var _clipPath, _rect, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V75H350V150H300zM300,0H150V200H0V150z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 300,
    fill: "#00247d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0L300,150M300,0L0,150",
    stroke: "#fff",
    strokeWidth: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0L300,150M300,0L0,150",
    stroke: "#cf142b",
    strokeWidth: 20,
    clipPath: "url(#cp)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150,0V200M0,75H350",
    stroke: "#fff",
    strokeWidth: 50
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150,0V200M0,75H350",
    stroke: "#cf142b",
    strokeWidth: 30
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0V150H0V300H600V0z",
    fill: "#00247d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s1",
    transform: "translate(0,-102)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M0,-22.5V0H12",
    transform: "rotate(18,0,-22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(288)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s7"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(24)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(48)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(96)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    transform: "rotate(168)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s7",
    transform: "rotate(168)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.af7bee35bddbd758ce1eda86dd76da1f.svg";
export { ForwardRef as ReactComponent };